import { CSSResultGroup, html, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LightController } from '../../../controllers/light-controller';

import componentStyles from './ghs-search-bar.css.lit';
import '../../ghs-icon/ghs-icon';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import globalStyles from './ghs-search-bar.global.scoped.css.lit';
import { GhsHeader } from '../ghs-header';

export type SearchPlaceholder = string;

/**
 * The Search Bar component
 *
 * @element ghs-search-bar
 */

@customElement('ghs-search-bar')
export class GhsSearchBar extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightController = new LightController(this, globalStyles);

  /**
   * The search bar label.
   * @param phoneContactNumber
   * @default Number
   */
  @property()
  label: String;

  close() {
    const ghsHeader: Element | null | undefined =
      this.closestElement('ghs-header');
    if (ghsHeader instanceof GhsHeader) {
      return ghsHeader.expansionStateFunction('search');
    } else {
      return () => {};
    }
  }

  render(): TemplateResult {
    return html`
      <div class="search-bar">
        <div class="search-bar-component-wrapper">
          ${this.site === 'BH'
            ? html`
                <button
                  class="close"
                  type="button"
                  aria-label="close search"
                  @click=${this.close()}
                >
                  <ghs-icon
                    name="accordion-collapse"
                    size="32px"
                    mobile-size="32px"
                  ></ghs-icon>
                </button>
              `
            : nothing}
          <div class="search-label">${this.label}</div>
          <div class="search-bar-form-wrapper">
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
}
